import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    editEmail: 'Edit the email address',
    inputEmailLabel: 'An email will be sent to:',
    remindInvitation: 'Relaunch by e-mail',
    resendInvitation: 'Resend the invitation',
    resendInvitationInfo: 'You may send a new invitation after 24h has passed.',
    resendInvitationInputError:
      'You may send a new invitation to this email address once 24h has passed.',
  },
  fr: {
    cancel: 'Annuler',
    editEmail: 'Editer l’adresse e-mail',
    inputEmailLabel: 'Un e-mail sera envoyé à :',
    remindInvitation: 'Relancer par e-mail',
    resendInvitation: 'Renvoyer l’invitation',
    resendInvitationInfo:
      'Vous pourrez envoyer une nouvelle invitation passé un délai de 24h',
    resendInvitationInputError:
      'Vous pourrez envoyer une nouvelle invitation à cette adresse passé un délai de 24h',
  },
} as const);
